import './index.scss';
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { TextField } from '@material-ui/core';
import clsx from 'clsx';
import { toAbsoluteUrl } from '_metronic';
import '_metronic/_assets/sass/pages/login/login-1.scss';
import { requests as authRequests } from 'redux/auth/reducer';
import { getStatusLogin } from 'redux/auth/selector';
import { actions as i18nActions } from '_metronic/ducks/i18n';

const footerStyles = {
  legal: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    marginTop: 'auto',
    padding: '12px 16px',
    backgroundColor: '#ffffff',
    fontSize: '12px',
    color: '#6b6b6b',
    flexWrap: 'wrap',
    textAlign: 'center',
  },
  logoWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  logoLink: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  logoImg: {
    width: '44px',
    height: '31px',
    objectFit: 'contain',
  },
  linksBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
  },
  linksRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
  },
  link: {
    color: '#3f3f3f',
    textDecoration: 'none',
    fontSize: '12px',
    lineHeight: '16px',
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  divider: {
    color: '#9a9a9a',
    lineHeight: '16px',
  },
  copy: {
    color: '#8a8a8a',
    fontSize: '12px',
    lineHeight: '16px',
  },
};

const layoutStyles = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  body: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
  },
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Login(props) {
  const queryParams = useQuery();

  const LATAM_BG = toAbsoluteUrl('/media/bg/bg-3.jpg');
  const EUROPE_BG = toAbsoluteUrl('/media/bg/bg-5.jpg');
  let isLatam = true;
  let backgroundImg = LATAM_BG;

  if (
    [
      'staging.garantiawf.com',
      'localhost',
      'www.myafprojecttool.com',
      'myafprojecttool.com',
    ].includes(window.location.hostname)
  ) {
    isLatam = false;
    backgroundImg = EUROPE_BG;
  }

  console.log(window.location.hostname);

  const { intl, login, hasError, isLoading, setLanguage } = props;
  const [loading, setLoading] = useState(false);
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: '2.5rem',
  });

  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: '3.5rem' });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: '2.5rem' });
  };

  useEffect(() => {
    const defaultLang = isLatam ? 'ar' : 'gb';
    const lang = queryParams.get('lang') ?? defaultLang;
    if (lang == 'br') {
      setLanguage('br');
    } else if (lang == 'en' || lang == 'gb') {
      setLanguage('gb');
    } else {
      setLanguage(lang.toLowerCase());
    }
  }, [queryParams, setLanguage, isLatam]);

  useEffect(() => {
    if (isLoading) {
      enableLoading();
    } else {
      disableLoading();
    }
  }, [isLoading]);

  const [attempts, setAttempts] = useState(0);
  const [lockoutTime, setLockoutTime] = useState(null);

  const handleLoginAttempt = (values) => {
    if (attempts >= 5) {
      // Si ya ha fallado 5 veces, calculamos el tiempo de desbloqueo
      const currentTime = new Date();
      const unlockTime = new Date(currentTime.getTime() + 15 * 60000); // Bloqueo de 15 minutos
      setLockoutTime(unlockTime); // Establecemos lockoutTime en el estado
      return; // Salimos sin hacer nada más (no permitimos el login)
    }

    // Si la autenticación falla, incrementamos el número de intentos
    login({ body: values });
    setAttempts(attempts + 1);
  };

  useEffect(() => {
    // Reseteamos el número de intentos a 0 después de que se haya desbloqueado
    if (lockoutTime && new Date() >= lockoutTime) {
      setAttempts(0);
      setLockoutTime(null); // Limpiamos el lockoutTime una vez se haya desbloqueado
    }
  }, [lockoutTime]);

  const cookiePreferencesLabel = intl.formatMessage({
    id: 'Preferencias de cookies',
  });
  const reservedRightsLabel = intl.formatMessage({
    id: 'Derechos Reservados',
  });
  const copyrightYear = new Date().getFullYear();

  return (
    <>
      <div className="kt-grid kt-grid--ver kt-grid--root">
        <div
          id="kt_login"
          className="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1"
        >
          <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
            <div
              className="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
              style={{
                //backgroundImage: `url(${toAbsoluteUrl('/media/bg/bg-3.jpg')})`,
                //backgroundImage: `url(${toAbsoluteUrl('/media/bg/bg-5.jpg')})`,
                //backgroundImage: `url(${toAbsoluteUrl('/media/bg/xmas/bg-xmas.jpg',)})`, //xmas remove
                backgroundImage: `url(${backgroundImg})`,
              }}
            >
              <div className="kt-grid__item">
                <Link to="/" className="kt-login__logo">
                  <img
                    width="250"
                    height="44"
                    alt="Logo"
                    // src={toAbsoluteUrl('/media/logos/logo-es-blanco.png')}
                    src={toAbsoluteUrl(
                      intl.formatMessage({ id: 'LOGO-BLANCO' }),
                    )}
                  />
                </Link>
              </div>
              <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
                <div className="kt-grid__item kt-grid__item--middle">
                  <h3 className="kt-login__title">
                    {isLatam && <FormattedMessage id="3M Window Films" />}

                    {!isLatam && (
                      <>
                        3M <span className="architectural">architectural</span>
                        <span className="finishes">finishes</span>
                      </>
                    )}
                  </h3>
                  <h4 className="kt-login__subtitle">
                    {/* <FormattedMessage id="La mejor solución en control solar, confort, seguridad y privacidad para tu automóvil, empresa y hogar" /> 
                      <FormattedMessage id="La mejor solución en control solar, confort, seguridad y privacidad para tu automóvil, empresa y hogar" />*/}
                  </h4>
                </div>
              </div>
            </div>

            <div
              className="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper"
              style={layoutStyles.wrapper}
            >
              <div className="kt-login__head">
                {/* <img
                  src={`${toAbsoluteUrl('/media/bg/xmas/trees.png')}`}
                  className="santa"
                  style={
                    //xmas remove
                    {
                      width: '100px',
                      display: 'flex',
                      marginLeft: 'auto',
                    }
                  }
                /> */}
              </div>

              <div className="kt-login__body" style={layoutStyles.body}>
                <div className="kt-login__form">
                  <div className="kt-login__title">
                    <h3>
                      <FormattedMessage id="Ingresa tus datos" />
                    </h3>
                  </div>

                  <Formik
                    initialValues={{
                      username: '',
                      password: '',
                    }}
                    validate={(values) => {
                      const errors = {};

                      if (!values.username) {
                        errors.username = intl.formatMessage({
                          id: 'Debe ingresar un nombre de usuario',
                        });
                      }

                      if (!values.password) {
                        errors.password = intl.formatMessage({
                          id: 'Debe ingresar una contraseña',
                        });
                      }

                      return errors;
                    }}
                    onSubmit={(values, { setStatus, setSubmitting }) => {
                      handleLoginAttempt(values);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                    }) => (
                      <form
                        noValidate={true}
                        autoComplete="off"
                        className="kt-form"
                        onSubmit={handleSubmit}
                      >
                        {hasError && attempts < 5 && (
                          <div role="alert" className="alert alert-danger">
                            <div className="alert-text">
                              {intl.formatMessage({
                                id: 'Usuario o contraseña invalidos',
                              })}
                            </div>
                          </div>
                        )}

                        {attempts >= 5 && lockoutTime && (
                          <div
                            role="alert"
                            className="alert alert-danger text-center"
                          >
                            <div className="alert-text">
                              {intl.formatMessage({
                                id:
                                  'Máximo de intentos alcanzado. Reintenta a las:',
                              })}{' '}
                              {lockoutTime.toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit',
                              })}
                            </div>
                          </div>
                        )}

                        <div className="form-group">
                          <TextField
                            type="text"
                            label="User"
                            margin="normal"
                            className="kt-width-full"
                            name="username"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.username}
                            helperText={touched.username && errors.username}
                            error={Boolean(touched.username && errors.username)}
                          />
                        </div>

                        <div className="form-group">
                          <TextField
                            type="password"
                            margin="normal"
                            label="Password"
                            className="kt-width-full"
                            name="password"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.password}
                            helperText={touched.password && errors.password}
                            error={Boolean(touched.password && errors.password)}
                          />
                        </div>

                        <div className="kt-login__actions">
                          <button
                            id="kt_login_signin_submit"
                            type="submit"
                            disabled={isLoading}
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
                              },
                            )}`}
                            style={loadingButtonStyle}
                          >
                            <FormattedMessage id="Ingresar" />
                          </button>
                        </div>
                      </form>
                    )}
                  </Formik>
                  <Link className="text-center" to="/reset-password">
                    {' '}
                    <h5>
                      {intl.formatMessage({
                        id: 'Olvide mi contraseña',
                      })}
                    </h5>{' '}
                  </Link>
                  <Link className="text-center" to="/pre-register">
                    {' '}
                    <h5>
                      {intl.formatMessage({
                        id: 'Registrate aquí',
                      })}
                    </h5>{' '}
                  </Link>
                </div>
              </div>

              <div className="m-footer_legal" style={footerStyles.legal}>
                {/* <div className="m-footer_legal--logo" style={footerStyles.logoWrap}>
                  <a
                    className="h-linkNoUnderline"
                    href="https://www.3M.com/"
                    aria-label="3M Logo - Opens in a new window"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={footerStyles.logoLink}
                  >
                    <img
                      src="/media/logo-mobile-footer.png"
                      alt="3M Logo"
                      style={footerStyles.logoImg}
                    />
                  </a>
                </div> */}

                <div style={footerStyles.linksBlock}>
                  <div
                    className="m-footer_legalLinks"
                    style={footerStyles.linksRow}
                  >
                    {/* <a
                      href="/3M/es_AR/inicio/aviso-legal/"
                      className="m-footer_legalLink"
                      title="Aviso Legal"
                      aria-label="Aviso Legal"
                      target="_self"
                      style={footerStyles.link}
                    >
                      Aviso Legal
                    </a> */}
                    {/* <div className="m-footer_legalSpan" style={footerStyles.divider}>
                      |
                    </div> */}
                    {/* <a
                      href="/3M/es_AR/inicio/politica-privacidad/"
                      className="m-footer_legalLink"
                      title="Política de Privacidad"
                      aria-label="Política de Privacidad"
                      target="_self"
                      style={footerStyles.link}
                    >
                      Política de Privacidad
                    </a> */}
                    {/* <div className="m-footer_legalSpan" style={footerStyles.divider}>
                      |
                    </div> */}
                    <button
                      type="button"
                      className="js-gdprPrefs m-footer_legalLink"
                      title={cookiePreferencesLabel}
                      aria-label={cookiePreferencesLabel}
                      style={footerStyles.link}
                      onClick={() => window.showConsentPreferencesPopup()}
                    >
                      {cookiePreferencesLabel}
                    </button>
                  </div>
                  <div className="m-footer_copyRight" style={footerStyles.copy}>
                    {`© 3M ${copyrightYear}. ${reservedRightsLabel}`}
                  </div>
                </div>
              </div>

              {/*  <img
                src={toAbsoluteUrl('https://i.ibb.co/2npZ0N1/rb-15966.png')} // Cambia el path al PNG que desees usar
                alt="Icono"
                style={{
                  position: 'absolute',
                  top: '90%',
                  right: '210px', // Ajusta según lo necesites
                  transform: 'translateY(-50%)',
                  height: '210px',
                }}
              /> */}
              {/* <div className="kt-login__footer">
                {/* <FormattedMessage id="Necesita una cuenta" />{' '}
                <Link
                  to="/auth/forgot-password"
                  className="kt-link kt-login__link-forgot"
                >
                  <FormattedMessage id="Solicitar" />
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export const mapDispatchToProps = (dispatch) => ({
  login: (payload) => dispatch(authRequests.create(payload)),
  setLanguage: (lang) => {
    dispatch(i18nActions.setLanguage(lang));
  },
});

export default injectIntl(connect(getStatusLogin, mapDispatchToProps)(Login));
